import { getDownloadURL, ref as storageRef } from 'firebase/storage';

import { storage } from '../shared/api/firebase/config';

const DEFAULT_DRIVE_PROXY_BASE_URL = 'https://rda-backend-thuq.onrender.com';

const readText = (value) => String(value || '').trim();

const resolveDriveProxyBaseUrl = () => {
  const fromEnv = readText(
    import.meta.env.VITE_RDA_API_BASE_URL ||
    import.meta.env.VITE_BACKEND_BASE_URL ||
    import.meta.env.VITE_API_BASE_URL
  );

  return (fromEnv || DEFAULT_DRIVE_PROXY_BASE_URL).replace(/\/+$/, '');
};

const resolveStoragePath = (docData) => {
  return readText(
    docData?.storagePath ||
    docData?.storage_path ||
    docData?._metadata?.storage_path
  );
};

const resolveDirectUrl = (docData) => {
  return readText(
    docData?.fileUrl ||
    docData?.url ||
    docData?.downloadUrl ||
    docData?.mirror_url ||
    docData?.webContentLink ||
    docData?.webViewLink
  );
};

export const resolveDocumentUrl = async (docData) => {
  const engine = docData?.storageEngine && typeof docData.storageEngine === 'object'
    ? docData.storageEngine
    : null;

  if (readText(engine?.provider).toLowerCase() === 'gdrive') {
    const access = readText(engine?.access).toLowerCase();
    if (access === 'public') {
      const publicUrl = readText(
        engine?.webViewLink ||
        engine?.webContentLink ||
        docData?.fileUrl ||
        docData?.url ||
        docData?.downloadUrl
      );
      if (publicUrl) return publicUrl;
    }

    const fileId = readText(engine?.fileId || engine?.id);
    if (fileId) {
      return `${resolveDriveProxyBaseUrl()}/drive/stream/${encodeURIComponent(fileId)}`;
    }
  }

  const storagePath = resolveStoragePath(docData);
  if (storagePath && !storagePath.toLowerCase().startsWith('gdrive://')) {
    return getDownloadURL(storageRef(storage, storagePath));
  }

  return resolveDirectUrl(docData);
};

export default resolveDocumentUrl;
